import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useAccount } from "wagmi";
import { LOOKUP_ADMIN } from "../config";

const STORAGE_KEY = "futurex_view_as";

const WalletViewContext = createContext(null);

export function WalletViewProvider({ children }) {
    const { address } = useAccount();
    const [viewAs, setViewAsState] = useState(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) || null;
        } catch {
            return null;
        }
    });

    const isAdmin =
        address && LOOKUP_ADMIN && address?.toLowerCase() === LOOKUP_ADMIN.toLowerCase();

    const setViewAs = useCallback(
        (addr) => {
            if (!isAdmin) return;
            try {
                if (addr) {
                    localStorage.setItem(STORAGE_KEY, addr);
                } else {
                    localStorage.removeItem(STORAGE_KEY);
                }
            } catch {
                // ignore storage errors
            }
            setViewAsState(addr || null);
        },
        [isAdmin],
    );

    const clearViewAs = useCallback(() => {
        try {
            localStorage.removeItem(STORAGE_KEY);
        } catch {
            // ignore
        }
        setViewAsState(null);
    }, []);

    // Clear viewAs if we lose admin status
    useEffect(() => {
        if (!isAdmin && viewAs) {
            clearViewAs();
        }
    }, [isAdmin, viewAs, clearViewAs]);

    const effectiveAddress = (isAdmin && viewAs) ? viewAs : address;

    return (
        <WalletViewContext.Provider value={{ viewAs: effectiveAddress, setViewAs, clearViewAs, isAdmin }}>
            {children}
        </WalletViewContext.Provider>
    );
}

export function useWalletView() {
    const ctx = useContext(WalletViewContext);
    if (!ctx) {
        throw new Error("useWalletView must be used inside WalletViewProvider");
    }
    return ctx;
}
